"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.fakeSignExtrinsic = exports.signExtrinsic = void 0;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var util_1 = require("@polkadot/util");
var errors_1 = require("@ledgerhq/errors");
var hw_app_polkadot_1 = __importDefault(require("@ledgerhq/hw-app-polkadot"));
var hw_1 = require("../../hw");
var operation_1 = require("../../operation");
var js_buildTransaction_1 = require("./js-buildTransaction");
var logic_1 = require("./logic");
var MODE_TO_TYPE = {
    send: "OUT",
    bond: "BOND",
    unbond: "UNBOND",
    rebond: "BOND",
    withdrawUnbonded: "WITHDRAW_UNBONDED",
    nominate: "NOMINATE",
    chill: "CHILL",
    setController: "SET_CONTROLLER",
    claimReward: "REWARD_PAYOUT",
    "default": "FEES"
};
var MODE_TO_PALLET_METHOD = {
    send: "balances.transferKeepAlive",
    bond: "staking.bond",
    bondExtra: "staking.bondExtra",
    unbond: "staking.unbond",
    rebond: "staking.rebond",
    withdrawUnbonded: "staking.withdrawUnbonded",
    nominate: "staking.nominate",
    chill: "staking.chill",
    setController: "staking.setController",
    claimReward: "staking.payoutStakers"
};
var getExtra = function (type, account, transaction) {
    var _a;
    var extra = MODE_TO_PALLET_METHOD[transaction.mode]
        ? {
            palletMethod: MODE_TO_PALLET_METHOD[transaction.mode === "bond" && !(0, logic_1.isFirstBond)(account)
                ? "bondExtra"
                : transaction.mode]
        }
        : {};
    switch (type) {
        case "OUT":
            return __assign(__assign({}, extra), { transferAmount: new bignumber_js_1.BigNumber(transaction.amount) });
        case "BOND":
            return __assign(__assign({}, extra), { bondedAmount: new bignumber_js_1.BigNumber(transaction.amount) });
        case "UNBOND":
            return __assign(__assign({}, extra), { unbondedAmount: new bignumber_js_1.BigNumber(transaction.amount) });
        case "WITHDRAW_UNBONDED":
            return __assign(__assign({}, extra), { withdrawUnbondedAmount: new bignumber_js_1.BigNumber(((_a = account.polkadotResources) === null || _a === void 0 ? void 0 : _a.unlockedBalance) || 0) });
        case "NOMINATE":
            return __assign(__assign({}, extra), { validators: transaction.validators });
    }
    return extra;
};
var buildOptimisticOperation = function (account, transaction, fee) {
    var _a;
    var type = ((_a = MODE_TO_TYPE[transaction.mode]) !== null && _a !== void 0 ? _a : MODE_TO_TYPE["default"]);
    var value = type === "OUT"
        ? new bignumber_js_1.BigNumber(transaction.amount).plus(fee)
        : new bignumber_js_1.BigNumber(fee);
    var extra = getExtra(type, account, transaction);
    var operation = {
        id: (0, operation_1.encodeOperationId)(account.id, "", type),
        hash: "",
        type: type,
        value: value,
        fee: fee,
        blockHash: null,
        blockHeight: null,
        senders: [account.freshAddress],
        recipients: [transaction.recipient].filter(Boolean),
        accountId: account.id,
        transactionSequenceNumber: (0, logic_1.getNonce)(account),
        date: new Date(),
        extra: extra
    };
    return operation;
};
/**
 * Serialize a signed transaction in a format that can be submitted over the
 * Node RPC Interface from the signing payload and signature produced by the
 * remote signer.
 *
 * @param unsigned - The JSON representing the unsigned transaction.
 * @param signature - Signature of the signing payload produced by the remote signer.
 * @param registry - Registry used for constructing the payload.
 */
var signExtrinsic = function (unsigned, signature, registry) { return __awaiter(void 0, void 0, void 0, function () {
    var extrinsic;
    return __generator(this, function (_a) {
        extrinsic = registry.createType("Extrinsic", unsigned, {
            version: unsigned.version
        });
        extrinsic.addSignature(unsigned.address, signature, unsigned);
        return [2 /*return*/, extrinsic.toHex()];
    });
}); };
exports.signExtrinsic = signExtrinsic;
/**
 * Sign Extrinsic with a fake signature (for fees estimation).
 *
 * @param unsigned - The JSON representing the unsigned transaction.
 * @param registry - Registry used for constructing the payload.
 */
var fakeSignExtrinsic = function (unsigned, registry) { return __awaiter(void 0, void 0, void 0, function () {
    var fakeSignature;
    return __generator(this, function (_a) {
        fakeSignature = (0, util_1.u8aConcat)(new Uint8Array([1]), new Uint8Array(64).fill(0x42));
        return [2 /*return*/, (0, exports.signExtrinsic)(unsigned, fakeSignature, registry)];
    });
}); };
exports.fakeSignExtrinsic = fakeSignExtrinsic;
/**
 * Sign Transaction with Ledger hardware
 */
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return new rxjs_1.Observable(function (o) {
        function main() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var transport, transactionToSign, _b, unsigned, registry, payload, polkadot, r, signed, operation;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, (0, hw_1.open)(deviceId)];
                        case 1:
                            transport = _c.sent();
                            _c.label = 2;
                        case 2:
                            _c.trys.push([2, , 6, 7]);
                            o.next({
                                type: "device-signature-requested"
                            });
                            if (!transaction.fees) {
                                throw new errors_1.FeeNotLoaded();
                            }
                            transactionToSign = __assign(__assign({}, transaction), { amount: (0, logic_1.calculateAmount)({
                                    a: account,
                                    t: transaction
                                }) });
                            return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(account, transactionToSign, true)];
                        case 3:
                            _b = _c.sent(), unsigned = _b.unsigned, registry = _b.registry;
                            payload = registry
                                .createType("ExtrinsicPayload", unsigned, {
                                version: unsigned.version
                            })
                                .toU8a({
                                method: true
                            });
                            polkadot = new hw_app_polkadot_1["default"](transport);
                            return [4 /*yield*/, polkadot.sign(account.freshAddressPath, payload)];
                        case 4:
                            r = _c.sent();
                            return [4 /*yield*/, (0, exports.signExtrinsic)(unsigned, r.signature, registry)];
                        case 5:
                            signed = _c.sent();
                            o.next({
                                type: "device-signature-granted"
                            });
                            operation = buildOptimisticOperation(account, transactionToSign, (_a = transactionToSign.fees) !== null && _a !== void 0 ? _a : new bignumber_js_1.BigNumber(0));
                            o.next({
                                type: "signed",
                                signedOperation: {
                                    operation: operation,
                                    signature: signed,
                                    expirationDate: null
                                }
                            });
                            return [3 /*break*/, 7];
                        case 6:
                            (0, hw_1.close)(transport, deviceId);
                            return [7 /*endfinally*/];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        }
        main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
    });
};
exports["default"] = signOperation;
//# sourceMappingURL=js-signOperation.js.map